import React, { useState } from 'react';
import Calendar from 'react-calendar';
import PropTypes from 'prop-types';
import './index.scss';

import 'react-calendar/dist/Calendar.css';

const DateRange = ({ onChangeProp, show, ...props }) => {
	const [value, onChange] = useState(new Date());

	const handleChange = e => {
		onChange(e);
		onChangeProp(e);
	};
	return (
		<div
			className={`${!show && 'fade'} position-absolute`}
			style={{ zIndex: show ? '12' : '0', display: show ? 'block' : 'none' }}
		>
			<Calendar
				className={'shadow border rounded'}
				onChange={handleChange}
				calendarType='Arabic'
				value={value}
				allowPartialRange={true}
				selectRange={true}
				{...props}
			/>
		</div>
	);
};
// type: PropTypes.string,
//   validationStatus: PropTypes.string,
//   defaultValue: PropTypes.string,
//   error: PropTypes.object,
DateRange.propTypes = {
	onChangeProp: PropTypes.func,
	show: PropTypes.bool
};

export default DateRange;
